export type FeatureRolloutFilter = "all" | "overridden" | "plan";

export function filterFeatureRolloutSalons<T extends { overriddenBySuperAdmin?: boolean | null; name: string }>(salons: T[], search: string, filter: FeatureRolloutFilter) {
  const term = search.trim().toLowerCase();
  return salons.filter((salon) => {
    const matchesSearch = !term || salon.name.toLowerCase().includes(term);
    const matchesFilter = filter === "all" || (filter === "overridden" ? !!salon.overriddenBySuperAdmin : !salon.overriddenBySuperAdmin);
    return matchesSearch && matchesFilter;
  });
}

export function featureRolloutOrigin(overriddenBySuperAdmin?: boolean | null) {
  return overriddenBySuperAdmin ? "Liberação administrativa" : "Conjunto do plano";
}
